import { styled } from '@mui/system'
import { IconButton } from '@mui/material'

import { SlideMenuStateButtonProps } from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideMenuStateButton/SlideMenuStateButton'

const SlideMenuOpenCloseButton = styled(IconButton, {
	shouldForwardProp: props => props !== 'isOpen',
})<SlideMenuStateButtonProps>(({ theme, isOpen }) => ({
	backgroundColor: theme.palette.common.white,
	padding: '0.45rem 0.2rem 0.45rem 0.7rem',
	border: `0.0625rem solid ${theme.palette.grey[200]}`,
	boxShadow: '0 0.1875rem 0.375rem 0 rgba(0, 0, 0, 0.16)',
	position: 'absolute',
	top: 25,
	right: -20,
	transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
	transition: 'transform 0.5s',
}))

export { SlideMenuOpenCloseButton }
